/* global axios */
import ApiClient from './ApiClient';

class TelegramReportsAPI extends ApiClient {
  constructor() {
    super('telegram_reports', { accountScoped: true });
  }

  getReport({
    botInboxId,
    from,
    to,
    groupBy,
    campaignsPage,
    campaignsPerPage,
  }) {
    const params = new URLSearchParams();
    params.append('bot_inbox_id', String(botInboxId));
    if (from) params.append('from', String(from));
    if (to) params.append('to', String(to));
    if (groupBy) params.append('group_by', String(groupBy));
    if (campaignsPage) params.append('campaigns_page', String(campaignsPage));
    if (campaignsPerPage)
      params.append('campaigns_per_page', String(campaignsPerPage));

    return axios.get(`${this.url}?${params.toString()}`);
  }
}

export default new TelegramReportsAPI();
